<div class="grid-x grid-margin-x teaser">
  <h1 class="cell text-center" [innerHTML]="textkeyprefix + 'headline' | translate: welcomePlaceholder"></h1>
  <div class="cell small-12 medium-offset-2 medium-3">
      <app-advisor-image class="adv-img" path="/foc/foc-intro.svg"></app-advisor-image>
  </div>
  <div class="cell small-12 medium-5">
      <p class="callout" [innerHTML]="textkeyprefix + 'intro' | translate"></p>
  </div>
</div>

<form (ngSubmit)="onSubmit()">
  <div class="grid-x grid-margin-x grid-margin-y check-wrapper">
    <fieldset class="cell small-12 medium-6">
      <legend [innerHTML]="textkeyprefix + 'altbau.selection.headline' | translate"></legend>
      <input type="checkbox" name="altbau-checkbox" id="altbau" (change)="selectInterest($event)" value="altbau" [checked]="anfrage?.gefoerdertWird?.indexOf('altbau') !== -1"
             aria-controls="button-teaser" [attr.aria-expanded]="anfrage?.gefoerdertWird?.indexOf('altbau') !== -1">
      <label for="altbau" class="checkbox-button primary">
        <app-advisor-image [path]="'/foc/foc-einstieg-altbau.svg'"></app-advisor-image>
        <span [innerHTML]="textkeyprefix + 'altbau' | translate"></span>
      </label>
      <input type="checkbox" name="neubau-checkbox" id="neubau" (change)="selectInterest($event)" value="neubau" [checked]="anfrage?.gefoerdertWird?.indexOf('neubau') !== -1"
             aria-controls="button-teaser" [attr.aria-expanded]="anfrage?.gefoerdertWird?.indexOf('neubau') !== -1">
      <label for="neubau" class="checkbox-button primary neubau">
        <app-advisor-image [path]="'/foc/foc-einstieg-neubau.svg'"></app-advisor-image>
        <span [innerHTML]="textkeyprefix + 'neubau' | translate"></span>
      </label>
    </fieldset>

    <fieldset class="cell small-12 medium-4">
      <legend [innerHTML]="textkeyprefix + 'elektromobilitaet.selection.headline' | translate"></legend>
      <input type="checkbox" name="elektro" id="elektromobilitaet" (change)="selectInterest($event)" value="elektromobilitaet" [checked]="anfrage?.gefoerdertWird?.indexOf('elektromobilitaet') !== -1"
             aria-controls="button-teaser" [attr.aria-expanded]="anfrage?.gefoerdertWird?.indexOf('elektromobilitaet') !== -1">
      <label for="elektromobilitaet" class="checkbox-button primary elektro">
        <app-advisor-image class="adv-img" [path]="'/foc/foc-einstieg-elektromobilitaet.svg'"></app-advisor-image>
        <span [innerHTML]="textkeyprefix + 'elektromobilitaet' | translate"></span>
      </label>
    </fieldset>
  </div>

  <div class="grid-x grid-margin-x">
    <div class="cell small-12 medium-offset-1 medium-10">
      <div id="button-teaser" class="button-wrapper" [class.background]="anfrage?.gefoerdertWird?.length > 0">
        @if (anfrage?.gefoerdertWird?.length > 0) {
          <div [innerHTML]="textkeyprefix + 'callout' | translate"></div>
        }
        @if (showError && anfrage?.gefoerdertWird?.length <= 0) {
          <div role="alert" class="form-errors" [innerHTML]="'foerdermittelcheck.einstieg.submit.teaser.error' | translate"></div>
        }
        <button class="button inline-arrow-right" type="submit" (click)="onSubmitClick()" [class.disabled]="anfrage?.gefoerdertWird?.length === 0" [innerHTML]="textkeyprefix + 'submit' | translate"></button>
      </div>
    </div>
  </div>
</form>
